/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = { "default": require("core-js/library/fn/reflect/own-keys"), __esModule: true };



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/reflect/own-keys.js
// module id = 1065
// module chunks = 60